import * as RSUConstants from './RSUConstants';

// Object.assign is not yet fully supported in all browsers, so we fallback to
// a polyfill
import { produce } from 'immer';
const assign = Object.assign || require('object.assign');

const initialState = {};

export default function RSUReducer(state = initialState, action) {
    switch(action.type){
        case RSUConstants.RSU_DEVICE_STATE_ADD: {
            if (state[action.payload]) {
                return state;
            }
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isRSURepoDataFetching: false,
                    isRSURepoDataFetched: false,
                    isRSURepoDataFetchFailed: false,
                    displayRSURepoModal: false,
                    rsuRepoFilesList : []
                }
            });
            return assign({}, state, newState);
        }
        case RSUConstants.RSU_DEVICE_STATE_REMOVE: {
            const newState = produce(state, (draft) => {
                if (draft[action.payload]) {
                    delete draft[action.payload];
                }
            });
            return assign({}, newState);
        }
        case RSUConstants.RSU_REPO_MODAL_CONTROL : {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    displayRSURepoModal: action.payload.showModal
                };
            })
            return assign({}, state, newState);
        }

        case RSUConstants.RSU_GET_REPO_FILES_INFO_REQUEST : {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isRSURepoDataFetching : true,
                    isRSURepoDataFetched : false,
                    isRSURepoDataFetchFailed : false
                };
            })
            return assign({}, state, newState);
        }
        case RSUConstants.RSU_GET_REPO_FILES_INFO_SUCCESS : {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isRSURepoDataFetching : false,
                    isRSURepoDataFetched : true,
                    isRSURepoDataFetchFailed : false,
                    rsuRepoFilesList : action.payload.newState
                };
            })
            return assign({}, state, newState);
        }

        case RSUConstants.RSU_GET_REPO_FILES_INFO_FAILURE : {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isRSURepoDataFetching : false,
                    isRSURepoDataFetched : false,
                    isRSURepoDataFetchFailed : true,
                    rsuRepoFilesList : []
                };
            })
            return assign({}, state, newState);
        }

        case RSUConstants.RSU_RESET_ERRORS : {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isRSURepoDataFetching : false,
                    isRSURepoDataFetched : false,
                    isRSURepoDataFetchFailed : false,
                    rsuRepoFilesList : []
                };
            })
            return assign({}, state, newState);
        }
        default:
            return state;
    }
}